/* unplugin-vue-components disabled */import script from "./StoreList.vue?vue&type=script&setup=true&lang=js"
export * from "./StoreList.vue?vue&type=script&setup=true&lang=js"

import "./StoreList.vue?vue&type=style&index=0&id=0b59a8d6&lang=scss"

const __exports__ = script;

export default __exports__